export enum WrapCrossAlignment {
  start = 1,
  end,
  center,
}
